import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { WHY_US } from '../../data/content';
import { useLanguage } from '../../i18n/LanguageContext';
export function WhyChooseUs() {
  const {
    lang,
    t
  } = useLanguage();
  return <section className="w-full bg-white py-24 lg:py-32" data-id="element-197" data-mp="2f7nqxfst74jr">
      <div className="mx-auto max-w-container px-6" data-id="element-198" data-mp="2f877as2t9kvo">
        <SectionHeading eyebrow={t.why.eyebrow} title={t.why.title} description={t.why.description} data-id="element-199" data-mp="32xhxxgqg5yw3" />

        <ul className="mt-16 grid gap-x-12 gap-y-12 md:grid-cols-2 lg:grid-cols-3" data-id="element-200" data-mp="36yboyiz6rtt7">
          {WHY_US.map((item, i) => <Reveal as="li" key={item.copy.en.title} delay={i * 0.05} data-id="element-201" data-mp="2t5c9ggzelzln" data-mpi={i}>
              <div className="border-t border-navy-100 pt-7" data-id="element-202" data-mp="2y58cacwd7kzm">
                <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 text-gold-dark" data-id="element-203" data-mp="3lvkklovivjqq">
                  <item.Icon className="h-5 w-5" aria-hidden="true" data-id="element-204" data-mp="3qnm51y2uggru" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-navy" data-id="element-205" data-mp="1vckx95brr97c">
                  {item.copy[lang].title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal-light" data-id="element-206" data-mp="1r84tb9lpubur">
                  {item.copy[lang].description}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}